import * as Sentry from '@sentry/browser';
import bootstrapper from '../bootstrapper';

export var setSentryContext = (moduleName, extraContext = {}) => {
  if (!bootstrapper.sentryDsn) {
    return;
  }

  if (bootstrapper.userUuid) {
    Sentry.setUser({ id: bootstrapper.userUuid });
  }

  Sentry.setTag('logger', 'JavaScript');

  if (moduleName) {
    Sentry.setTag('module', moduleName);
  }

  Sentry.setContext('data', {
    braintreeEnvironment: bootstrapper.braintreeEnvironment,
    amplitudeEnabled: bootstrapper.amplitudeEnabled,
    facebookPixelEnabled: bootstrapper.facebookPixelEnabled,
    paypalEnabled: bootstrapper.paypalEnabled,
    activeExperiments: bootstrapper.activeExperiments
      ? JSON.stringify(bootstrapper.activeExperiments, null, 2) : undefined,
    locale: bootstrapper.locale,
    host: bootstrapper.host,
    ...extraContext,
  });
};

export default (moduleName, extraContext = {}, initOptions = {}) => {
  if (bootstrapper.sentryDsn) {
    Sentry.init({ dsn: bootstrapper.sentryDsn, ...initOptions });
    setSentryContext(moduleName, extraContext);

    window.Sentry = Sentry;
  }
};
